import FormItem from "@components/formItem";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import { MaskedInputLabel } from "@pages/profile-v2/pages/withdraw/baseItems";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems";
import React from "react";
import MaskInput from "react-maskinput";
import { Box, Content, ContentTitle, MaskedInput } from "../baseItems";
import Base from "./base";

export default class SendToFriend extends Base {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			stake: "",
			selectedCurrency: "",
			account: "",
			accountValue: "",
			showFriendMask: false,
			canForward: false,
		};
		this.friendInputRef = React.createRef();
	}

	handleFocus = (field) => {
		this.setState({ [field]: true });
	};

	handleBlur = (field, value) => {
		const cleanedValue = value.replace(/_/g, "").trim();
		const isEmptyOrMasked = cleanedValue === "";
		this.setState(
			{
				[field]: false,
				[`${field.replace("show", "").toLowerCase()}Value`]: isEmptyOrMasked
					? ""
					: cleanedValue,
			},
			this.checkRequiredFields
		);
	};

	onEnterValue = (field, e) => {
		const value = e.target.value.replace(/_/g, "").trim();
		this.setState({ [field]: value, [`${field}Value`]: value }, this.checkRequiredFields);
	};

	checkRequiredFields = () => {
		const { stake, accountValue, selectedCurrency } = this.state;
		if (stake && accountValue && selectedCurrency) {
			this.setState({ canForward: true });
		} else {
			this.setState({ canForward: false });
		}
	};

	getStep1(translate) {
		const { stake, selectedCurrency, showFriendMask, accountValue } = this.state;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<BoxWrapper>
					<FormItem onRegister={() => this.registerField({ name: "account" })}>
						<Box>
							<MaskedInput>
								<MaskInput
									ref={this.friendInputRef}
									alwaysShowMask={window.IS_MARS ? true : false}
									onFocus={() => this.handleFocus("showFriendMask")}
									onBlur={(e) =>
										this.handleBlur("showFriendMask", e.target.value)
									}
									value={showFriendMask ? accountValue : this.state.account}
									mask="****************************************"
									maskChar={showFriendMask ? "_" : ""}
									size={40}
									onChange={(e) => this.onEnterValue("account", e)}
								/>
								<MaskedInputLabel
									isFocused={showFriendMask}
									hasValue={accountValue}>
									{translate("FRIEND_ID")}
								</MaskedInputLabel>
							</MaskedInput>
						</Box>
					</FormItem>
				</BoxWrapper>
			</Content>
		);
	}

	goForward(step) {
		const { stake, selectedCurrency } = this.state;
		const { selectedWithdraw } = this.props;

		if (!this.state.canForward) return;

		const currency = selectedWithdraw.currencies.find(
			(item) => item.currency === selectedCurrency
		);

		if (currency && stake < currency.withdraw.min) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MIN",
				title: "ERROR",
			});
			return;
		}

		if (currency && stake > currency.withdraw.max) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MAX",
				title: "ERROR",
			});
			return;
		}

		const newStep = step + 1;
		this.setState({ currentStep: newStep });
	}

	makeExternalPayment() {
		const { stake, account, selectedCurrency } = this.state;
		let withdrawData = {
			type: "SendToFriend",
			amount: {
				value: Number(stake),
				currency: selectedCurrency ? selectedCurrency : "TRY",
			},
			friendId: account,
			language: this.getActiveLanguageCode(),
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}

	render() {
		const { canForward } = this.state;
		return super.render();
	}
}
